import React, { useEffect, useRef, useState } from 'react'
import styles from './SubItems.module.scss'

/**
 * @internal Do not use this component directly.
 * A parent component for sub-items that will be displayed when a navigation item is clicked.
 */
export const SubItems = ({
  children,
  isOpen,
  isCollapsed,
}: {
  children?: React.ReactNode
  isOpen?: boolean
  isCollapsed?: boolean
}) => {
  const [maxHeight, setMaxHeight] = useState(0)
  const submenuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (submenuRef.current) {
      if (isOpen) {
        setMaxHeight(submenuRef.current.scrollHeight)
      } else {
        setMaxHeight(0)
      }
    }
  }, [isOpen])

  if (isCollapsed || !children) return null
  return (
    <div
      className={styles.wrapper}
      ref={submenuRef}
      style={{ maxHeight: isOpen ? `${maxHeight}px` : '0' }}
    >
      <div className={styles.list}>{children}</div>
    </div>
  )
}
